import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';
import isEmpty from 'lodash-es/isEmpty';

import watch from 'redux-watch';

import { changeFieldValueAndUpdate } from 'app/services/businessFunctionHelpers';
import store from 'app/store/index';
import { getDictionary } from 'app/store/data/formsConfig';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const tryToChangeValueFromProfile = (field: FieldsEnum, valuePath: string) => {
  const userProfile = store.getState().user;
  const value = get(userProfile, valuePath);
  if (value) {
    changeFieldValueAndUpdate(field, value);
  }
};

const cityDictionaryWatcher = watch(
  () =>
    getDictionary(
      store.getState(),
      FormsEnum.CalculationForm,
      `${FieldsEnum.OwnerLegalAddressCity}_dictionary`
    ),
  undefined,
  isEqual
);

const getCityDictionary = () =>
  store.getState().formsConfig[FormsEnum.CalculationForm].dictionaries[
    `${FieldsEnum.OwnerLegalAddressCity}_dictionary`
  ];

const setCityWhenDictAppear = () => {
  const unsubscribe = store.subscribe(
    cityDictionaryWatcher(() => {
      tryToChangeValueFromProfile(
        FieldsEnum.OwnerLegalAddressCity,
        'user.address.city'
      );
      unsubscribe();
    })
  );
};

const insurantAutocomplete = {
  fillNameAndSurnameFromProfile() {
    tryToChangeValueFromProfile(FieldsEnum.OwnerName, 'user.firstName');
    tryToChangeValueFromProfile(FieldsEnum.OwnerLastName, 'user.lastName');
  },
  fillAddressFromProfile() {
    tryToChangeValueFromProfile(
      FieldsEnum.OwnerLegalAddressZipCode,
      'user.address.zipCode'
    );

    const dictionary = getCityDictionary();

    if (!isEmpty(dictionary)) {
      tryToChangeValueFromProfile(
        FieldsEnum.OwnerLegalAddressCity,
        'user.address.city'
      );
      return;
    }
    setCityWhenDictAppear();
  },
};

export default insurantAutocomplete;
